// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class GetChatAccountUsers
{
    chatId: string;
    accountNumber: string;
}